export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const FETCH_ACTIVITIES = 'FETCH_ACTIVITIES';
export const UPDATE_REV_CARD = 'UPDATE_REV_CARD';

export const RESET_ACTIVITIES = 'RESET_ACTIVITIES';

export const RETAIN_STATE = 'RETAIN_STATE';
export const SET_FILTER = 'SET_FILTER';
